import React from 'react'

const Category = () => {
    return (
        <div className='frameshadow mb_30'>Category</div>
    )
}

export default Category